import { render, staticRenderFns } from "./ResetPasswordStep3.vue?vue&type=template&id=2f8e2f74&scoped=true"
import script from "./ResetPasswordStep3.vue?vue&type=script&lang=js"
export * from "./ResetPasswordStep3.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordStep3.vue?vue&type=style&index=0&id=2f8e2f74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8e2f74",
  null
  
)

export default component.exports